module.exports = __webpack_public_path__ + "static/media/lds-logo_mk.8ea804d5.svg";